import React from 'react';
import Tooltip from './Tooltip';

const Statistics = ({ children, showAbandonment = true, showRecovered = true }) => {
  const getGridCols = () => {
    if (!showAbandonment) return 'grid-cols-4';
    return showRecovered ? 'grid-cols-6' : 'grid-cols-5';
  };
  
  return (
    <div className={`grid gap-x-6 flex-1 mr-6 ${getGridCols()}`}>
      {children}
    </div>
  );
};

const StatisticsItem = ({ children }) => {
  return <div className="truncate">{children}</div>;
};

const StatisticsText = ({ children, tooltip }) => {
  return (
    <div className="text-gray-700 text-sm font-normal">
      {tooltip ? (
        <Tooltip
          label={tooltip}
          placement="top"
          triggerClassName="relative z-10"
        >
          {children}
        </Tooltip>
      ) : (
        children
      )}
    </div>
  );
};

const StatisticsMetric = ({ children }) => {
  return <h6 className="font-medium truncate">{children}</h6>;
};

Statistics.Item = StatisticsItem;
Statistics.Text = StatisticsText;
Statistics.Metric = StatisticsMetric;

export default Statistics;
